import { Box, type Theme } from "@mui/material";
import { Pill } from "@src/appV2/redesign/system/ui-components";

import { type ShiftTimeProposalStatus } from "../../Shifts/ShiftTimeProposals/types";

interface ShiftTimeProposalStatusPillProps {
  status?: ShiftTimeProposalStatus;
  expired: boolean;
}

export function ShiftTimeProposalStatusPill(props: ShiftTimeProposalStatusPillProps) {
  const { status = "PROPOSED", expired } = props;

  const STATUS_LABELS: Record<ShiftTimeProposalStatus, string> = {
    ACCEPTED: "New shift time accepted",
    PROPOSED: "New shift time",
    DECLINED: "New shift time declined",
    APPLIED: "New shift time accepted",
    CANCELLED: "New shift time", // Not used
  };

  const showExpiryLabel = expired && status === "PROPOSED";

  const pillLabel = showExpiryLabel ? "Proposal expired" : STATUS_LABELS[status];

  const color = (theme: Theme) => {
    // FIXME: Automatically disabled during ESLint config update
    switch (status) {
      case "ACCEPTED":
      case "APPLIED": {
        return theme.palette.intent?.success.text;
      }

      case "DECLINED": {
        return theme.palette.intent?.error.text;
      }

      case "PROPOSED": {
        return expired ? theme.palette.text.primary : theme.palette.intent?.warning.text;
      }

      default: {
        return theme.palette.text.primary;
      }
    }
  };

  const outlineColor = (theme: Theme) => {
    // FIXME: Automatically disabled during ESLint config update
    switch (status) {
      case "ACCEPTED": {
        return theme.palette.intent?.success.text;
      }

      case "APPLIED": {
        return theme.palette.intent?.success.text;
      }

      case "DECLINED": {
        return theme.palette.intent?.error.border;
      }

      case "PROPOSED": {
        return expired ? theme.palette.border?.primary : theme.palette.intent?.warning.border;
      }

      default: {
        return theme.palette.border?.primary;
      }
    }
  };

  return (
    <>
      <Pill
        variant="outlined"
        size="small"
        label={pillLabel}
        color={color}
        outlineColor={outlineColor}
        backgroundColor={(theme) => theme.palette.background.quaternary}
        sx={{
          zIndex: 3,
        }}
      />
      {expired && (
        // use Box overlay to achieve disabled text affect on ShiftTimeProposalMessageCard
        <Box
          sx={{
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 2,
          }}
        />
      )}
    </>
  );
}
